import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    CustomReportSalesProjectsSummaryView,
    GetExternalSalesProjectsValuesResultType,
    GetSalesProjectsExtendedColumnChartValuesResultType,
    GetSalesProjectsLineChartValuesResultType,
    GetSalesProjectsMetricsValuesResultType,
    GetSalesProjectsSummaryValuesParameters,
    ReportResultColumnDto,
    SalesProjectsClient,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class SalesProjectService extends CustomReportServiceBase<
    SalesProjectsClient,
    CustomReportSalesProjectsSummaryView
> {
    constructor(protected override client: SalesProjectsClient) {
        super(client);
    }

    async getSalesEstimatesBoxesValues(parameters: GetSalesProjectsSummaryValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.salesProjectsGetSalesProjectsBoxesValues(parameters));
    }

    async getSalesEstimatesMetricsValues(
        parameters: GetSalesProjectsSummaryValuesParameters
    ): Promise<GetSalesProjectsMetricsValuesResultType> {
        return await lastValueFrom(this.client.salesProjectsGetSalesProjectsMetricsValues(parameters));
    }

    async getSalesEstimatesSummaryValues(
        parameters: GetSalesProjectsSummaryValuesParameters
    ): Promise<GetExternalSalesProjectsValuesResultType[]> {
        return await lastValueFrom(this.client.salesProjectsGetSalesProjectsSummaryValues(parameters));
    }

    async getColumnChartValues(
        parameters: GetSalesProjectsSummaryValuesParameters
    ): Promise<GetSalesProjectsExtendedColumnChartValuesResultType[]> {
        return await lastValueFrom(this.client.salesProjectsGetSalesProjectsColumnChartValuesValues(parameters));
    }

    async getLineChartValues(
        parameters: GetSalesProjectsSummaryValuesParameters
    ): Promise<GetSalesProjectsLineChartValuesResultType[]> {
        return await lastValueFrom(this.client.salesProjectsGetSalesProjectsLineChartValuesValues(parameters));
    }

    override async saveCustomReport(
        body: CustomReportSalesProjectsSummaryView
    ): Promise<CustomReportSalesProjectsSummaryView> {
        if (body.isPublic) return await lastValueFrom(this.client.salesProjectsSaveCatalogReport(body));
        else return await lastValueFrom(this.client.salesProjectsSaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportSalesProjectsSummaryView> {
        return await lastValueFrom(this.client.salesProjectsGetCustomReport(id));
    }

    override async shareReport(body: CustomReportSalesProjectsSummaryView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.salesProjectsCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportSalesProjectsSummaryView> {
        return await lastValueFrom(this.client.salesProjectsGetSharedReport(id));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.salesProjectsResultAvailableColumns(organizationIds));
    }
}
